import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

import { SFDownloadIcon } from "../icons";
import SFIconButton from "../button/iconButton";
import { SFGridContainerItem, SFGridItem, SFStack } from "../grid";
import SFChipList from "../chip/chipList";

import getStyled from "../../hooks/getStyled";

import Box from "@mui/material/Box";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import _ from "lodash";
import SFTypography from "../typography";
import { useTranslation } from "react-i18next";
import Slide from "@mui/material/Slide";

const { styled } = getStyled();

const BoxStyled = styled(Box)(({ theme }) => ({
  "&": {
    border: "none",
    backgroundColor: "#F6F6FA",
    display: "flex",
    alignItems: "center",
    padding: "10px",
    borderRadius: "4px",
  },
}));

const SFStackStyled = styled(SFStack)(({ theme }) => ({
  padding: theme.spacing(2.5),

  borderLeft: `1px solid ${theme.palette.grey225.main}`,
  borderRight: `1px solid ${theme.palette.grey225.main}`,
  borderTop: `1px solid ${theme.palette.grey225.main}`,
  borderBottom: `1px solid ${theme.palette.grey225.main}`,
  marginBottom: theme.spacing(2),
  backgroundColor: theme.palette.white.main,
  borderTopLeftRadius: "4px",
  borderTopRightRadius: "4px",
}));

const SFSearch = ({
  handleDownload,
  onSearchChanged,
  customSearchComponents = null,
  pills = [],
  actions = [],
  xs = 12,
  md = 4,
  lg = 3,
  managePills = false,
}) => {
  const { t } = useTranslation();

  const inputRef = useRef(null);
  const [value, setValue] = useState("");
  const [_pills, setPills] = useState([]);

  useEffect(() => {
    onSearchChanged(_pills);
  }, [_pills]);

  return (
    <SFStackStyled>
      <SFGridContainerItem spacing={1}>
        <SFGridItem xs={xs} md={md} lg={lg}>
          <BoxStyled
            sx={{
              display: "flex",
              alignItems: "flex-end",
              height: "40px",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <SearchIcon fontSize="medium" />
            <InputBase
              inputRef={inputRef}
              placeholder={t("components.search.searchPlaceHolder")}
              sx={{
                ml: 2,
                flex: 1,
                fontSize: "14px",
                ".MuiFormLabel-root": {
                  left: "unset",
                  top: "27px",
                  right: "0px",
                  transformOrigin: "top right",
                },
              }}
              onChange={(e) => {
                setValue(e.currentTarget.value);
              }}
              onKeyDown={(e) => {
                if (e.target.value.length > 0) {
                  if (e.keyCode == 13) {
                    if (managePills) {
                      if (
                        _pills.findIndex(
                          (i) => i == e.target.value.toLowerCase()
                        ) == -1
                      ) {
                        const _pillsLocal = _.cloneDeep(_pills);
                        _pillsLocal.push(e.target.value.toLowerCase());
                        setPills(_pillsLocal);
                      }
                    } else {
                      onSearchChanged(e.target.value.toLowerCase());
                    }
                    inputRef.current.value = "";
                    setValue("");
                  }
                }
                if (e.keyCode == 27) {
                  inputRef.current.value = "";
                  setValue("");
                }
              }}
              fullWidth
            />
            <Slide direction="left" in={!!value} mountOnEnter unmountOnExit>
              <SFTypography
                variant="body2"
                sx={{
                  color: "rgba(0, 0, 0, 0.5)",
                }}
              >
                {t("components.search.prompt")}
              </SFTypography>
            </Slide>
          </BoxStyled>
        </SFGridItem>
        {(customSearchComponents || pills.length > 0 || _pills.length > 0) && (
          <SFGridItem xs={12} md>
            <SFStack justifyContent="flex-start" direction="row" spacing={1}>
              {customSearchComponents}
              {pills.length > 0 && (
                <SFChipList
                  items={pills}
                  //onDeleteAll={onClearFilters && clearAllFiltersHandler}
                  canDelete
                  //getCustomStyles={(item) => getStyles(item.key)}
                />
              )}
              {_pills.length > 0 && (
                <SFChipList
                  items={_pills.map((p) => ({
                    value: p,
                    onDelete: () =>
                      setPills(_.cloneDeep(_pills).filter((i) => i != p)),
                  }))}
                  //onDeleteAll={onClearFilters && clearAllFiltersHandler}
                  canDelete
                />
              )}
            </SFStack>
          </SFGridItem>
        )}
        {(handleDownload || actions) && (
          <SFGridItem xs={12} md="auto">
            <SFStack justifyContent="flex-end" direction="row" spacing={1}>
              {handleDownload && (
                <SFIconButton type="button" onClick={() => handleDownload()}>
                  <SFDownloadIcon color={"grey500"} />
                </SFIconButton>
              )}
              {actions.map((i) => (
                <>{i}</>
              ))}
            </SFStack>
          </SFGridItem>
        )}
      </SFGridContainerItem>
    </SFStackStyled>
  );
};

SFSearch.propTypes = {
  handleDownload: PropTypes.func,
  onSearchChanged: PropTypes.func,
  customSearchComponents: PropTypes.node,
  pills: PropTypes.array,
  actions: PropTypes.arrayOf(PropTypes.node),
  xs: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
  managePills: PropTypes.bool,
};
export default SFSearch;
